import { lazy } from 'react';
import ComponentLoader from 'src/components/ComponentLoader';
import Module from 'src/config/models/Module';
import ModuleBundle from 'src/config/models/ModuleBundle';

export const DeviceIssueListingViewModule = new Module({
  id: 'DEVICE-ISSUE:RESULT-TABLE',
  name: 'Device Issues',
  label: 'Device Issues',
  path: 'device-issue',
  Component: ComponentLoader(
    lazy(() => import('src/content/reports/DeviceIssueListing/View'))
  ),
  actions: {
    edit: {
      id: 'DEVICE-ISSUE:VIEW:*',
      name: 'VIEW',
      label: 'View'
    },
    // close: {
    //   id: 'DEVICE-ISSUE:CLOSE:*',
    //   name: 'close',
    //   label: 'Close'
    // }
  }
});

export const DeviceIssueListingAddModule = new Module({
  id: 'DEVICE-ISSUE:ADD:*',
  name: 'deviceIssueAdd',
  path: 'device-issue/add',
  Component: ComponentLoader(
    lazy(() => import('src/content/reports/DeviceIssueListing/Form'))
  ),
  actions: {
    add: {
      id: 'DEVICE-ISSUE:ADD:*',
      name: 'Device Issue Add',
      label: 'Raise ticket'
    }
  }
});

export const DeviceIssueListingEditModule = new Module({
  id: 'DEVICE-ISSUE:VIEW:DETAILS',
  name: 'Device Issue Edit',
  path: 'device-issue/details/:ticketId',
  Component: ComponentLoader(
    lazy(() => import('src/content/reports/DeviceIssueListing/Form'))
  )
});

const DeviceIssueListingModules = [
  DeviceIssueListingViewModule,
  DeviceIssueListingAddModule,
  DeviceIssueListingEditModule
];

export default new ModuleBundle('DeviceIssueListing', DeviceIssueListingModules);
